<template>
  <!-- 对话框 -->
  <el-drawer title="添加司机信息" :visible.sync="show" :with-header="false" :before-close="closeDialog" size="60%"
    :wrapperClosable="false">

    <!-- 基本信息表单 -->
    <div class="form-box">


      <template>

        <el-form ref="form" :model="submit_data" label-width="80px" style="height: 90vh; overflow-y: auto;">


          <el-form-item label="标题:" label-width='120px'>
            <el-input type="textarea" :rows="4" v-model="submit_data.title"
              :placeholder="submit_rules.title.placeholder" style="width: 80%;">
            </el-input>
          </el-form-item>



          <!-- 下拉选择使用状态 -->
          <el-form-item label="选择使用状态:" label-width='120px'>

            <el-select v-model="submit_data.status" :placeholder="submit_rules.status.placeholder"
              style="width: 150px; margin-right: 20px;" clearable>

              <el-option label="启用" value="1"></el-option>
              <el-option label="禁用" value="0"></el-option>

            </el-select>

          </el-form-item>






          <el-form-item label="开始时间:" label-width='120px'>

            <el-date-picker v-model="submit_data.start_time" type="datetime"
              :placeholder="submit_rules.start_time.placeholder" format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss" style="margin-right: 10px;">
            </el-date-picker>

          </el-form-item>

          <el-form-item label="结束时间:" label-width='120px'>

            <el-date-picker v-model="submit_data.end_time" type="datetime"
              :placeholder="submit_rules.end_time.placeholder" format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss" style="margin-right: 10px;">
            </el-date-picker>

          </el-form-item>

          <el-form-item label="累计完成数量:" label-width='120px'>

            <el-input v-model.number="submit_data.num" style="width: 80px;">
            </el-input>

          </el-form-item>

          <el-form-item label="总奖励次数:" label-width='120px'>

            <el-input v-model.number="submit_data.award_count" style="width: 80px;">
            </el-input>

          </el-form-item>

          <el-form-item label="推广内容:" label-width='120px'>

            <quill-editor ref="myTextEditor" v-model="submit_data.content" :options="submit_rules.content">
            </quill-editor>

          </el-form-item>




          <div>
            <p style="width: 120px; text-align: right;font-size: 14px;padding-right: 12px;margin-bottom: 10px;">奖励内容:
            </p>
            <el-form-item label="表现分:" label-width='150px'>
              <div style="width: 100%;">
                <el-input v-model.number="monitor_point" style="width: 80px;">
                </el-input>
              </div>
            </el-form-item>

          </div>




        </el-form>



        <!-- 对话框底部按钮 -->
        <div style="display: flex;justify-content: center;margin-top: 20px;">
<!--          <el-button type="primary" @click="onSubmit">保存</el-button>-->
          <submitBtn @onSubmitDig="onSubmitDig" @toJSON="toJSON" :data="submit_data" :rules="submit_rules" :url="submit_url" :JSON_Boolean="true"></submitBtn>
          <el-button @click="closeDialog">关闭</el-button>
        </div>

      </template>

    </div>


  </el-drawer>
</template>

<script>
  var _this;

  import axios from 'axios'; // AJAX封装类

  import 'quill/dist/quill.core.css';
  import 'quill/dist/quill.snow.css';
  import 'quill/dist/quill.bubble.css';
  import {
    quillEditor
  } from 'vue-quill-editor';

  export default {
    components: {
      quillEditor
    },
    props: {
      'isShow': Boolean,
    },
    watch: {

      isShow(newData, oldData) {

        _this.show = true;

      },
    },
    data() {
      return {

        show: false,


        submit_url:'/promote/addDriverPromoteConfSubmit',

        monitor_point:"0",

        // 表单数据
        submit_data: {
          title: '',
          content: '',
          synchronization: {
            monitor_point: '0',
          },
          start_time: '',
          end_time: '',
          status: '',
          num: '',
          award_count:''
        },

        submit_rules: {
          title: {
            placeholder: '请输入标题',
            rules: {
              required: true,
              message: '标题需小于等于100字',
              regulation: 'elt_str',
              rulesData: 100
            }
          },

          content: {
            placeholder: '推广内容',
            rules: {
              required: true,
              message: '推广内容错误',
              regulation: 'egt_str',
              rulesData: 0
            }
          },



          start_time: {
            placeholder: '请选择开始时间',
            rules: {
              required: true,
              message: '开始时间错误',
              regulation: 'gt_str',
              rulesData: 5
            }
          },
          end_time: {
            placeholder: '请选择结束时间',
            rules: {
              required: true,
              message: '结束时间错误',
              regulation: 'elt',
              rulesData: 9
            }
          },
          status: {
            placeholder: '请选择使用状态',
            rules: {
              required: true,
              message: '使用状态错误',
              regulation: 'special',
              rulesData: '0|1'
            }
          },
          num: {
            placeholder: '请输入累计完成数量',
            rules: {
              required: true,
              message: '累计完成数量错误',
              regulation: 'between',
              rulesData: [0, 21]
            }
          },
          award_count: {
            placeholder: '请输入总奖励次数',
            rules: {
              required: true,
              message: '总奖励次数错误',
              regulation: 'between',
              rulesData: [0, 21]
            }
          }
        },

      };
    },
    created() {

      _this = this;

    },
    methods: {






      // 关闭方法
      closeDialog() {

        _this.submit_data = {
          title: '',
          content: '',
          synchronization: {
            monitor_point: '0',
          },
          start_time: '',
          end_time: '',
          status: '',
          num: '',
          award_count:''
        }
        _this.show = false;

      },


      toJSON(){

        _this.submit_data.synchronization = JSON.stringify(_this.monitor_point);


      },

      // 提交
      onSubmitDig() {


        // 触发父组件自定义事件刷新表格
        _this.$emit('onSubmit');
        _this.closeDialog();


      },





    }
  };
</script>

<style scoped>
  .form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }

  .el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }

  .avatar-uploader {
    width: 100px;
    height: 100px;
  }

  .avatar-uploader img {
    display: block;
    width: 100%;
    height: 100%;
  }

  .verify_remarks {
    font-size: 14px;
    color: #606266;
  }

  .quill-editor {
    width: 80%;
  }
</style>